import { FacetRangeFilter } from '../types';

export const RANGE_INITIAL_STATE: FacetRangeFilter = {
  from: 0,
  to: 0,
  step: 0.00001
} as const;
